module.exports = __webpack_public_path__ + "img/tx.39fda9da.jpg";